<div>
  <div>
  @for (item of entityModelFields(); track $index) {
    <div class="mb-2 grid grid-cols-12 gap-4">
      <div class="col-span-4"><input type="text" pInputText [(ngModel)]="item.fieldName" class="w-full" [id]="'field-name-' + $index"/></div>
      <div class="col-span-4"><p-select [options]="fieldTypes" [(ngModel)]="item.fieldType" optionLabel="label" optionLabel="label"  optionValue="value" placeholder="Select a type"  class="w-full" [id]="'field-type-' + $index"/></div>
      <div class="col-span-3"><p-togglebutton [(ngModel)]="item.required" onLabel="Obbligatorio" offLabel="Opzionale" class="w-full" [id]="'field-required-' + $index"/></div>
      <div class="col-span-1"><p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" (click)="onDelete($index)"/></div>
    </div>
  }


    <p-button icon="pi pi-plus" label="Aggiungi" severity="info" (click)="onAdd()" variant="text" />

  </div>
  <div>
    @if(!isFormValid()){
      <small>Non puoi inserire campi con lo stesso nome</small>
     }
  </div>

  <div >
    <div style="position:absolute; bottom:1rem">
      <p-button 
          class="w-full"
          styleClass="w-full"
          (click)="save()"
          icon="pi pi-save"
          label="Salva"
          severity="primary">
      </p-button>
    </div>
  </div>
</div>

